import {
  createContext,
  useContext, useState,
} from 'react';
import Notification from '../components/Notifications/Notification';

const PatientsContext = createContext();

export const PatientsProvider = ({ children }) => {
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleCloseSnackbar = () => setSnackbarIsOpen(false);
  const handleOpenSnackbar = (text, type) => {
    setSnackbarIsOpen(true);
    setMessage({ text, type });
  };

  return (
    <PatientsContext.Provider
      value={{
        handleOpenSnackbar,
      }}
    >
      <Notification
          open={snackbarIsOpen}
          autoClose={true}
          showCloseButton={true}
          message={message}
          handleClose={handleCloseSnackbar}
      />
      {children}
    </PatientsContext.Provider>
  );
};

export const usePatientsContext = () => useContext(PatientsContext);;
